import React, { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';

const LayerUITitle: FC<{ children: ReactNode }> = ({ children }) => (
  <Typography sx={{ fontWeight: '600', fontSize: 16, mb: 2 }}>{children}</Typography>
);

export { LayerUITitle };
